var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDqbIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9580_70626)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 6,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9580_70626)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 19,
    width: 14,
    height: 2,
    rx: 1,
    fill: "#7B86A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4454 5.36981C12.7813 5.14587 13.2189 5.14588 13.5548 5.36982L19.2517 9.16796C20.0749 9.7168 19.6864 11 18.697 11H7.3028C6.31339 11 5.92486 9.71677 6.7481 9.16795L12.4454 5.36981Z",
    fill: "#C6CAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3242 17.02V12.1831H18.335C18.6713 12.1831 18.9546 12.2361 19.1849 12.342C19.4153 12.448 19.5903 12.5954 19.7101 12.7843C19.8299 12.9685 19.8897 13.185 19.8897 13.4338C19.8897 13.6733 19.8368 13.876 19.7308 14.0419C19.6249 14.2077 19.4844 14.3367 19.3093 14.4288C19.1389 14.5164 18.95 14.567 18.7427 14.5808L18.8532 14.5048C19.0744 14.5141 19.2701 14.5739 19.4406 14.6845C19.6156 14.7951 19.7515 14.9402 19.8483 15.1198C19.9496 15.2949 20.0003 15.4883 20.0003 15.7003C20.0003 15.9582 19.9381 16.1886 19.8137 16.3912C19.6893 16.5893 19.5074 16.7437 19.2678 16.8542C19.0329 16.9648 18.745 17.02 18.4041 17.02H16.3242ZM17.2916 16.2323H18.2521C18.4962 16.2323 18.6851 16.177 18.8187 16.0665C18.9523 15.9513 19.0191 15.7901 19.0191 15.5828C19.0191 15.3755 18.95 15.212 18.8118 15.0922C18.6736 14.9724 18.4824 14.9125 18.2383 14.9125H17.2916V16.2323ZM17.2916 14.1939H18.1761C18.411 14.1939 18.5907 14.1409 18.715 14.035C18.8394 13.9244 18.9016 13.7701 18.9016 13.572C18.9016 13.3785 18.8394 13.2288 18.715 13.1229C18.5907 13.0123 18.4087 12.957 18.1692 12.957H17.2916V14.1939Z",
    fill: "#7B86A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2643 17.787L12.4954 15.0023H13.6079L15.4252 17.787H14.2643ZM13.138 17.1029C12.6681 17.1029 12.2535 16.9969 11.8942 16.785C11.5349 16.5731 11.2516 16.2806 11.0443 15.9075C10.8416 15.5297 10.7402 15.0944 10.7402 14.6015C10.7402 14.1086 10.8416 13.6756 11.0443 13.3024C11.2516 12.9247 11.5349 12.6299 11.8942 12.418C12.2535 12.206 12.6681 12.1001 13.138 12.1001C13.6125 12.1001 14.0294 12.206 14.3887 12.418C14.7526 12.6299 15.0336 12.9247 15.2317 13.3024C15.4344 13.6756 15.5357 14.1086 15.5357 14.6015C15.5357 15.0944 15.4344 15.5297 15.2317 15.9075C15.0336 16.2806 14.7526 16.5731 14.3887 16.785C14.0294 16.9969 13.6125 17.1029 13.138 17.1029ZM13.138 16.2322C13.4282 16.2322 13.6793 16.1654 13.8912 16.0318C14.1031 15.8982 14.2666 15.7117 14.3818 15.4721C14.4969 15.228 14.5545 14.9378 14.5545 14.6015C14.5545 14.2652 14.4969 13.9773 14.3818 13.7377C14.2666 13.4936 14.1031 13.3047 13.8912 13.1711C13.6793 13.0375 13.4282 12.9707 13.138 12.9707C12.8524 12.9707 12.6036 13.0375 12.3917 13.1711C12.1844 13.3047 12.0209 13.4936 11.9011 13.7377C11.7859 13.9773 11.7284 14.2652 11.7284 14.6015C11.7284 14.9378 11.7859 15.228 11.9011 15.4721C12.0209 15.7117 12.1844 15.8982 12.3917 16.0318C12.6036 16.1654 12.8524 16.2322 13.138 16.2322Z",
    fill: "#7B86A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 17.02V12.1831H7.64456C8.20196 12.1831 8.66492 12.2845 9.03345 12.4871C9.40198 12.6852 9.67377 12.9662 9.84882 13.3302C10.0285 13.6895 10.1183 14.1133 10.1183 14.6016C10.1183 15.0853 10.0285 15.5091 9.84882 15.873C9.67377 16.2369 9.40198 16.5202 9.03345 16.7229C8.66953 16.921 8.20426 17.02 7.63765 17.02H6ZM6.96739 16.1909H7.58928C7.97624 16.1909 8.28027 16.1287 8.50139 16.0043C8.72711 15.8753 8.88835 15.6933 8.98508 15.4584C9.08182 15.2189 9.13019 14.9333 9.13019 14.6016C9.13019 14.2699 9.08182 13.9866 8.98508 13.7517C8.88835 13.5121 8.72711 13.3278 8.50139 13.1989C8.28027 13.0699 7.97624 13.0054 7.58928 13.0054H6.96739V16.1909Z",
    fill: "#7B86A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9580_70626",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9580_70626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9580_70626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9580_70626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDqbIcon);
export default __webpack_public_path__ + "static/media/DQBIcon.7176405d8d706420b538e897ebcba629.svg";
export { ForwardRef as ReactComponent };